import { jsx as _jsx } from "nativewind/jsx-runtime";
import React, { useState } from 'react';
import { color } from '@/constant/color';
import * as S from './TextAreaV2.style';
export default function TextAreaV2(props) {
    const [focused, setFocused] = useState(false);
    const handleFocus = (e) => {
        var _a;
        setFocused(true);
        (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
    };
    return (_jsx(S.TextAreaContainer, { focused: focused, children: _jsx(S.Input, Object.assign({ placeholderTextColor: color.gray40, multiline: true }, props, { onFocus: handleFocus, onBlur: () => setFocused(false) })) }));
}
